<div id="billboardcomponent">
    <div class="headerbillboard">
        {{title}}
    </div>
    <div class="bodybillboard"  [ngStyle]="styleData">
        <ng-content></ng-content>
    </div>
</div>
